import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getSyncAllMoloniData,
  getSyncAllMoloniProductData,
  getSyncAllMoloniTpData,
} from "../../services/MoloniServices";
import { toast } from "react-toastify";
import Utils from "../../utils";

const Moloni = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isApp = Number(localStorage.getItem("isApp"));
  const [isAllSyncLoading, setIsAllSyncLoading] = useState(false);
  const [isAllSyncProductLoading, setIsAllSyncProductLoading] = useState(false);
  const [isAllSyncTpLoading, setIsAllSyncTpLoading] = useState(false);

  const handleBack = () => {
    if (isApp === 1) {
      navigate("/back-app");
    } else {
      navigate("/settings");
    }
  };

  const handleAllSyncMoloniData = () => {
    setIsAllSyncLoading(true);

    getSyncAllMoloniData()
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsAllSyncLoading(false);
      });
  };

  const handleAllSyncMoloniProductData = () => {
    setIsAllSyncProductLoading(true);

    getSyncAllMoloniProductData()
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsAllSyncProductLoading(false);
      });
  };

  const handleAllSyncMoloniTpData = () => {
    setIsAllSyncTpLoading(true);

    getSyncAllMoloniTpData()
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsAllSyncTpLoading(false);
      });
  };

  return (
    <div>
      <section className="content-header content-header-custom">
        <div className="container-fluid">
          <div className="row mb-2">
            {!isApp && (
              <>
                <div className="col-sm-6 d-flex align-items-center">
                  <button
                    type="button"
                    className="next-button btn btn-secondary"
                    onClick={() => navigate("/settings")}
                  >
                    <i className="bi bi-arrow-left"></i> {t("back")}
                  </button>

                  <button
                    type="button"
                    className="next-button btn btn-secondary ms-2"
                    onClick={handleAllSyncMoloniData}
                    disabled={isAllSyncLoading}
                  >
                    {isAllSyncLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("syncing")}
                      </>
                    ) : (
                      <>
                        <i className="bi bi-arrow-repeat me-2"></i>
                        {t("syncMoloniToTp")}
                      </>
                    )}
                  </button>

                  <button
                    type="button"
                    className="next-button btn btn-secondary ms-2"
                    onClick={handleAllSyncMoloniProductData}
                    disabled={isAllSyncProductLoading}
                  >
                    {isAllSyncProductLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("syncing")}
                      </>
                    ) : (
                      <>
                        <i className="bi bi-arrow-repeat me-2"></i>
                        {t("syncProductToMoloni")}
                      </>
                    )}
                  </button>

                  <button
                    type="button"
                    className="next-button btn btn-secondary ms-2"
                    onClick={handleAllSyncMoloniTpData}
                    disabled={isAllSyncTpLoading}
                  >
                    {isAllSyncTpLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("syncing")}
                      </>
                    ) : (
                      <>
                        <i className="bi bi-arrow-repeat me-2"></i>
                        {t("syncDataTpToMoloni")}
                      </>
                    )}
                  </button>
                </div>

                <div className="col-sm-6 text-end">
                  <h1 className="page-title">{t("moloni")}</h1>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
      {isApp === 1 && (
        <>
          <div className="col-sm-6 align-items-center">
            <button
              type="button"
              className="next-button btn btn-secondary"
              // onClick={() => {handleBack
              //   // if (isApp === 1) {
              //   //   navigate("/back-app");
              //   // } else {
              //   //   navigate("/settings");
              //   // }
              // }}
              onClick={handleBack}
            >
              <i className="bi bi-arrow-left"></i> {t("back")}
            </button>
          </div>

          <div className="col-sm-6 text-center mb-0">
            <h1 className="page-title fs-3">{t("moloni")}</h1>
          </div>
        </>
      )}

      <section className="content">
        <div className="container-fluid container-custom-height-new">
          <div className="card p-3">
            <div className="d-flex flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-custom-new w-100 w-sm-50 w-lg-25"
                onClick={() => navigate("/moloni-settings")}
                style={{ maxWidth: "300px" }}
              >
                {t("settings")}{" "}
                <span>
                  <i className="bi bi-gear"></i>
                </span>
              </button>
              <button
                type="button"
                className="btn btn-custom-new w-100 w-sm-50 w-lg-25"
                onClick={() => navigate("/moloni-products")}
                style={{ maxWidth: "300px" }}
              >
                {t("products")}{" "}
                <span>
                  <i className="bi bi-box-seam"></i>
                </span>
              </button>
              <button
                type="button"
                className="btn btn-custom-new w-100 w-sm-50 w-lg-25"
                onClick={() => navigate("/moloni-entities")}
                style={{ maxWidth: "300px" }}
              >
                {t("entities")}{" "}
                <span>
                  <i className="bi bi-gender-ambiguous"></i>
                </span>
              </button>
              <button
                type="button"
                className="btn btn-custom-new w-100 w-sm-50 w-lg-25"
                onClick={() => navigate("/moloni-document")}
                style={{ maxWidth: "300px" }}
              >
                {t("documents")}{" "}
                <span>
                  <i className="bi bi-file-earmark-text"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Moloni;
